import { BlockCategory } from './block-connection-categories'

const SERIOUS_OR_GENERAL_CONDUCT_BULLETS: readonly string[] = [
  'What happened and when',
  'Who was present or affected',
  'If prior warnings were issued',
  'Any evidence (messages, reports, etc.)',
  'Impact on the workplace',
]

/**
 * Dynamic bullets shown below the block-policy reason selector (biz app wizard +
 * ops-console). Keys align with {@link BlockCategory}.
 */
export const BLOCK_POLICY_NOTE_GUIDANCE_BULLETS: Readonly<
  Record<BlockCategory, readonly string[]>
> = {
  [BlockCategory.SAFETY]: [
    'Date, time, shift, and location',
    'Behavior observed and who witnessed it',
    'Actions taken (removed, tested, etc.)',
    'If an incident report was filed',
    'Equipment or people put at risk',
  ],
  [BlockCategory.CONDUCT_2]: SERIOUS_OR_GENERAL_CONDUCT_BULLETS,
  [BlockCategory.CONDUCT_1]: SERIOUS_OR_GENERAL_CONDUCT_BULLETS,
  [BlockCategory.ATTENDANCE]: [
    'Specific dates and shifts missed, cancelled, or late',
    'If advance notice was given and how much',
    'Pattern over time (e.g. past 30 days)',
    'If any prior warnings or communications issued',
    'Impact on the workplace',
  ],
  [BlockCategory.PERFORMANCE]: [
    'Tasks or requirements not met',
    'Measurable output if available (units, error rate, etc.)',
    'If training or guidance was provided beforehand',
    'If it was a single incident or repeated pattern',
    'How performance compared to expectations',
  ],
  [BlockCategory.OTHER]: [
    'Why none of the standard categories apply',
    'What happened and when',
    'Steps taken before this block',
  ],
}

/** Minimum-note disclaimer for companies with W2 among active employment types. */
export const BLOCK_POLICY_NOTE_LENGTH_DISCLAIMER_BUSINESS_W2 =
  "We know this feels like extra steps. We require this to protect your business, resolve disputes fairly, and meet legal obligations. Your response is confidential and won't be shared with the worker."

/** Minimum-note disclaimer for 1099-only companies (no W2 in active employment types). */
export const BLOCK_POLICY_NOTE_LENGTH_DISCLAIMER_BUSINESS_CONTRACTOR_1099 =
  "We know this feels like extra steps. We require this to protect your business and resolve disputes fairly. Your response is confidential and won't be shared with the worker."
